// externals
import { useSelector } from 'react-redux';

// selectors
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { scopedStateSelectors, ScopedStateProvider } from '@makemydeal/shared-scoped-store';

// components
import { OfferCommentsWrapper, DealCentralContainerCompact } from '../DeskingActivity.styles';
import { DeskingCardsContainerCompact } from './DeskingCard.style';
import OfferCommentsInterstate from '../OfferComments.interstate';
import BaseDealHeader from '../baseDealActivity/BaseDealHeader';
import BaseDealContainer from '../baseDealActivity/baseDealContainer/BaseDealContainer';
import * as dealModeSelectors from '@makemydeal/dr-dash-store/selectors/dealModeSelectors';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

const PRIMARY_CARDS_AMOUNT = 1;

export const DeskingActivityDealMultiple = () => {
    const theme = useInterstateTheme();
    const scopesOrder = useSelector(scopedStateSelectors.getScopesOrder);
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const isFnIDealMode = useSelector(dealModeSelectors.isFnIDealMode);
    const isMvLiteEnabled = useSelector(dealerSelectors.isMvLiteEnabled);

    const primaryScopeId = useSelector(scopedStateSelectors.getPrimaryScopeId);

    const cardsContainerProps = {
        cardsAmount: isFnIDealMode ? PRIMARY_CARDS_AMOUNT : scopesOrder.length,
        isDealCentralExperience,
        theme
    };

    const cardsContent = scopesOrder.map((scopeId: string) => {
        if (isFnIDealMode && scopeId !== primaryScopeId) {
            return null;
        }
        return (
            <ScopedStateProvider scopeId={scopeId} key={scopeId}>
                <BaseDealContainer scopeId={scopeId} />
            </ScopedStateProvider>
        );
    });

    return (
        <DealCentralContainerCompact>
            <BaseDealHeader />
            <DeskingCardsContainerCompact {...cardsContainerProps}>{cardsContent}</DeskingCardsContainerCompact>
            {!isFnIDealMode && !isMvLiteEnabled && (
                <OfferCommentsWrapper>
                    <OfferCommentsInterstate title="Offer Comments" textRows={1} />
                </OfferCommentsWrapper>
            )}
        </DealCentralContainerCompact>
    );
};
